import React, {useContext} from "react";
import { Asset, GeneralProject } from "../../../../../../interface/Server";
import AssetGroupListItem from './Sections/ListItems/AssetGroupListItem'
import AssetListItem from './Sections/ListItems/AssetListItem';
import GeneralProjectItem from './Sections/ListItems/GeneralProjectItem'
import { reducer } from "../../../../../../context";
import { useTranslation } from "react-i18next";

interface Props {
    assets: Array<Asset>,
    generalProjectList: Array<GeneralProject>,
    onSelectAsset: (asset: Asset) => void,
    onSelectProject: (project: GeneralProject) => void,
    loading?: boolean,
    isMobile?: boolean,
}

const USE_ASSET_GROUP = false; // queryGroup is unavailable so all results are un-grouped

const AssetList: React.FunctionComponent<Props> = (props) => {
    const { t, i18n } = useTranslation();
    const useChinese = i18n.language === 'zhTW' || i18n.language === 'cn';
    const {assets, generalProjectList, isMobile} = props;
    if(props.loading) {
        return <div/>
    }
    // if (!generalProjectList.projectName && (!assets || assets.length < 1)) return <div>
    //     沒有任何物品符合現有的篩選條件。
    // </div>;
    return (
        <>  
            {!!generalProjectList && generalProjectList.length && 
                generalProjectList.map((generalProject, index) => 
                    generalProject.projectName &&
                    <GeneralProjectItem item={generalProject} onSelectProject={props.onSelectProject} key={index} isMobile={isMobile}/>
                )
            }
            {(!assets || assets.length < 1) && 
                <div style={{ fontFamily: useChinese ? 'Microsoft Jhenghei' : 'Rambla', display: 'flex', flex: 1 }}>
                    <div style={{ color: 'black' }}>{t('noItemsAvailable')}</div>
                </div>}
            {USE_ASSET_GROUP ? 
                [] //assets.map((asset, index) => <AssetGroupListItem key={index} group={assetGroups}/>)
                :
                assets.map((asset, index) => {
                    if(asset.childrenAssets) {
                        return <AssetGroupListItem key={index} group={asset} onSelectAsset={props.onSelectAsset} isMobile={isMobile} />
                    }
                    return <AssetListItem key={index} asset={asset} onSelectAsset={props.onSelectAsset} isMobile={isMobile} />;
                })
            }
        </>
    )
};

export default AssetList;